// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8db9277","453":"8e254a44","455":"f4e92f14","977":"a9b114de"}[chunkId] + ".chunk.js";
};